var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useCallback } from 'react';
import moment from 'moment-timezone';
import { useWalkInListQuery, useAddWalkInClientMutation, useRemoveWalkInClientMutation, useWalkInListHistoryQuery, useWaitingListCurrentQuery, useWaitingListHistoryQuery, useAcceptWalkInSlotMutation, useNotifyWalkInSlotMutation, } from '../network/walkInListApi';
import { getSessionShop, useSession } from '../../../../../modules/infra/session';
import { t } from '../../../../../modules/infra/i18n';
// Translation keys for view types - explicit keys for better searchability
var VIEW_TYPE_TRANSLATION_KEYS = {
    current: 'appointment:walk_in_list.view_types.current',
    history: 'appointment:walk_in_list.view_types.history',
};
export var useWalkInListState = function (activeView, isModalOpen) {
    if (isModalOpen === void 0) { isModalOpen = false; }
    var _a = useState(null), error = _a[0], setError = _a[1];
    var session = useSession().data;
    var shop = getSessionShop(session);
    // Default to today's date for history view
    var _b = useState(moment()
        .tz((shop === null || shop === void 0 ? void 0 : shop.timezone) || 'UTC')
        .format('YYYY-MM-DD')), selectedDate = _b[0], setSelectedDate = _b[1];
    // Get today's date for current view
    var today = moment()
        .tz((shop === null || shop === void 0 ? void 0 : shop.timezone) || 'UTC')
        .format('YYYY-MM-DD');
    // Fetch walk-in clients
    var _c = useWalkInListQuery(isModalOpen), _d = _c.data, currentWalkInClients = _d === void 0 ? [] : _d, isLoadingCurrentWalkIns = _c.isLoading, currentWalkInQueryError = _c.error, refetchCurrentWalkIns = _c.refetch, isRefetchingCurrentWalkIns = _c.isFetching;
    var _e = useWalkInListHistoryQuery(activeView === 'current' ? today : selectedDate), _f = _e.data, historyWalkInClients = _f === void 0 ? [] : _f, isLoadingHistoryWalkIns = _e.isLoading, historyWalkInQueryError = _e.error, refetchHistoryWalkIns = _e.refetch;
    // Fetch waiting list clients
    var _g = useWaitingListCurrentQuery(isModalOpen), _h = _g.data, currentWaitingListClients = _h === void 0 ? [] : _h, isLoadingCurrentWaitingList = _g.isLoading, currentWaitingListQueryError = _g.error, refetchCurrentWaitingList = _g.refetch, isRefetchingCurrentWaitingList = _g.isFetching;
    var _j = useWaitingListHistoryQuery(activeView === 'current' ? today : selectedDate), _k = _j.data, historyWaitingListClients = _k === void 0 ? [] : _k, isLoadingHistoryWaitingList = _j.isLoading, historyWaitingListQueryError = _j.error, refetchHistoryWaitingList = _j.refetch;
    // Use the real mutations
    var addWalkInClientMutation = useAddWalkInClientMutation();
    var removeWalkInClientMutation = useRemoveWalkInClientMutation();
    var acceptWalkInSlotMutation = useAcceptWalkInSlotMutation();
    var notifyWalkInSlotMutation = useNotifyWalkInSlotMutation();
    // Transform walk-in clients to unified format
    var transformWalkInClients = useCallback(function (walkInClients) {
        return walkInClients.map(function (client) { return ({
            id: client.id,
            type: 'walk-in',
            customer: client.customer,
            services: client.services,
            createdAt: client.createdAt,
            status: client.status,
            position: 'position' in client ? client.position : undefined,
            appointmentNote: client.appointmentNote,
            customerNote: client.customerNote,
            duration: client.duration,
            expiresAt: client.expiresAt,
            timer: client.timer,
            notifiedAt: client.status === 'notified' ? client.statusUpdatedAt : null,
            statusUpdatedAt: client.statusUpdatedAt,
        }); });
    }, []);
    // Transform waiting list clients to unified format
    var transformWaitingListClients = useCallback(function (waitingListClients) {
        return waitingListClients.map(function (client) { return ({
            id: client.id,
            type: 'waiting-list',
            customer: client.customer,
            services: client.services || [],
            createdAt: client.createdAt,
            status: 'active',
            barberId: client.barberId,
            barberName: client.barber ? "".concat(client.barber.firstName, " ").concat(client.barber.lastName) : client.barberName,
        }); });
    }, []);
    // Combine and sort clients
    var getUnifiedClients = useCallback(function (walkInClients, waitingListClients) {
        if (!(shop === null || shop === void 0 ? void 0 : shop.id)) {
            return [];
        }
        var transformedWalkIns = transformWalkInClients(walkInClients);
        var transformedWaitingList = transformWaitingListClients(waitingListClients);
        var allClients = __spreadArray(__spreadArray([], transformedWalkIns, true), transformedWaitingList, true);
        return allClients.sort(function (a, b) { return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(); });
    }, [transformWalkInClients, transformWaitingListClients, shop === null || shop === void 0 ? void 0 : shop.id]);
    var historyClients = getUnifiedClients(historyWalkInClients, historyWaitingListClients);
    var unifiedClients = activeView === 'current'
        ? getUnifiedClients(__spreadArray(__spreadArray([], currentWalkInClients, true), historyWalkInClients, true), currentWaitingListClients // Only use current waiting list to avoid duplicates
        )
        : historyClients;
    var isLoading = !(shop === null || shop === void 0 ? void 0 : shop.id) ||
        (activeView === 'current'
            ? isLoadingCurrentWalkIns || isLoadingCurrentWaitingList || isLoadingHistoryWalkIns || isLoadingHistoryWaitingList
            : isLoadingHistoryWalkIns || isLoadingHistoryWaitingList);
    var isRefetching = activeView === 'current' &&
        (isRefetchingCurrentWalkIns ||
            isRefetchingCurrentWaitingList ||
            // Note: History queries don't have refetching enabled, so we don't include them here
            false);
    var queryError = activeView === 'current'
        ? currentWalkInQueryError || currentWaitingListQueryError
        : historyWalkInQueryError || historyWaitingListQueryError;
    if (queryError && !error && (shop === null || shop === void 0 ? void 0 : shop.id)) {
        setError(t('appointment:walk_in_list.errors.failed_to_load', {
            activeView: t(VIEW_TYPE_TRANSLATION_KEYS[activeView]),
            error: queryError.message || t('appointment:walk_in_list.errors.unknown_error'),
        }));
    }
    if (error && !(shop === null || shop === void 0 ? void 0 : shop.id)) {
        setError(null);
    }
    var addWalkInClient = useCallback(function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, addWalkInClientMutation.mutateAsync(payload)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    setError(t('appointment:walk_in_list.errors.failed_to_add'));
                    throw err_1;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [addWalkInClientMutation]);
    var removeWalkInClient = useCallback(function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, removeWalkInClientMutation.mutateAsync({
                            walkInItemId: clientId,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    setError(t('appointment:walk_in_list.errors.failed_to_remove'));
                    throw err_2;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [removeWalkInClientMutation]);
    var notifyWalkInClient = useCallback(function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
        var err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, notifyWalkInSlotMutation.mutateAsync({
                            walkInSlotId: clientId,
                            notifiedAt: new Date().toISOString(),
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_3 = _a.sent();
                    setError(t('appointment:walk_in_list.errors.failed_to_notify'));
                    throw err_3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [notifyWalkInSlotMutation]);
    var isNotifyingClientById = useCallback(function (clientId) {
        var _a;
        return notifyWalkInSlotMutation.isLoading && ((_a = notifyWalkInSlotMutation.variables) === null || _a === void 0 ? void 0 : _a.walkInSlotId) === clientId;
    }, [notifyWalkInSlotMutation.isLoading, notifyWalkInSlotMutation.variables]);
    var updateWalkInClient = useCallback(function (clientId, barberId) {
        acceptWalkInSlotMutation.mutate({
            barberId: barberId,
            walkInSlotId: clientId,
            sendNotifications: true,
            acceptedAt: new Date().toISOString(),
            dateTime: new Date().toISOString(),
        });
    }, [acceptWalkInSlotMutation]);
    var refreshWalkInList = useCallback(function () {
        if (activeView === 'current') {
            refetchCurrentWalkIns();
            refetchCurrentWaitingList();
            // Also refetch history queries since we're using them for current view
            refetchHistoryWalkIns();
            refetchHistoryWaitingList();
        }
        else {
            refetchHistoryWalkIns();
            refetchHistoryWaitingList();
        }
    }, [activeView, refetchCurrentWalkIns, refetchCurrentWaitingList, refetchHistoryWalkIns, refetchHistoryWaitingList]);
    var handleDateChange = useCallback(function (date) {
        setSelectedDate(date);
    }, []);
    return {
        unifiedClients: unifiedClients,
        isLoading: isLoading,
        isRefetching: isRefetching,
        error: error,
        activeView: activeView,
        selectedDate: selectedDate,
        addWalkInClient: addWalkInClient,
        removeWalkInClient: removeWalkInClient,
        notifyWalkInClient: notifyWalkInClient,
        updateWalkInClient: updateWalkInClient,
        refreshWalkInList: refreshWalkInList,
        setError: setError,
        handleDateChange: handleDateChange,
        isAddingClient: addWalkInClientMutation.isLoading,
        isRemovingClient: removeWalkInClientMutation.isLoading,
        isNotifyingClient: notifyWalkInSlotMutation.isLoading,
        isNotifyingClientById: isNotifyingClientById,
    };
};
